import * as cornerstone from "cornerstone-core";
import { CornerstoneImage, ImageLoaderResult } from "cornerstone-core";
import CancelableAxiosInstance from "../api/CancelableAxiosInstance";
import ImageUtils from "../util/ImageUtil";

const canvas = document.createElement("canvas");
let lastImageIdDrawn: string;

const createImage = (image: HTMLImageElement, imageId: string): CornerstoneImage => {
  // extract the attributes we need
  const rows = image.naturalHeight;
  const columns = image.naturalWidth;

  function getPixelData() {
    const imageData = getImageData();
    return imageData.data;
  }

  function getImageData() {
    let context;

    if (lastImageIdDrawn === imageId) {
      context = canvas.getContext("2d");
    } else {
      canvas.height = image.naturalHeight;
      canvas.width = image.naturalWidth;
      context = canvas.getContext("2d");
      context.drawImage(image, 0, 0);
      lastImageIdDrawn = imageId;
    }

    return context.getImageData(0, 0, image.naturalWidth, image.naturalHeight);
  }

  function getCanvas() {
    if (lastImageIdDrawn === imageId) {
      return canvas;
    }

    canvas.height = image.naturalHeight;
    canvas.width = image.naturalWidth;
    const context = canvas.getContext("2d");

    context.drawImage(image, 0, 0);
    lastImageIdDrawn = imageId;

    return canvas;
  }

  // Extract the various attributes we need
  return {
    imageId,
    minPixelValue: 0,
    maxPixelValue: 255,
    slope: 1,
    intercept: 0,
    windowCenter: 128,
    windowWidth: 255,
    render: cornerstone.renderWebImage,
    getPixelData,
    getCanvas,
    getImage: () => image,
    rows,
    columns,
    height: rows,
    width: columns,
    color: true,
    rgba: false,
    columnPixelSpacing: undefined,
    rowPixelSpacing: undefined,
    invert: false,
    sizeInBytes: rows * columns * 4,
  };
};

export const withClient = (
  client: CancelableAxiosInstance,
  scheme: string
): { (imageId: string): ImageLoaderResult } => {
  return (imageId: string): ImageLoaderResult => {
    if (imageId.startsWith(scheme)) imageId = imageId.substring(scheme.length);

    const promise = ImageUtils.pathToImageElement(client, imageId).then((image) => createImage(image, imageId));

    return {
      promise,
      cancelFn: () => {},
    };
  };
};
